import { render, staticRenderFns } from "./AddTournamentStageCover.vue?vue&type=template&id=2cfce6e3&"
import script from "./AddTournamentStageCover.vue?vue&type=script&lang=js&"
export * from "./AddTournamentStageCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports